// language=GraphQL
export const ALL_CONTENT_BLOCK_ASSIGNMENTS_QUERY = `query Query($withBlock: Boolean = false, $withBlockDeep: Boolean = false) {
  contentBlockAssignments: cmsContentBlockAssignments {
    id
    type
    block @include(if: $withBlock) {
      __typename
      ... on CmsTextBlock {
        id
        text

      }
      ... on CmsTextWithImageBlock {
        id
        title
        subtitle
        text
        imagePosition
        image @include(if: $withBlockDeep) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        imageFixedAspectRatio
        gallery @include(if: $withBlockDeep) {
          id
          images  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        link @include(if: $withBlockDeep) {
          id
          label
          targetBlank
          type
          url
          page  {
            id
            name
            onlineStatus
          }
          travel  {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
        }

      }
      ... on CmsPageHeaderBlock {
        id
        title
        text
        image @include(if: $withBlockDeep) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }

      }
      ... on CmsWysiwygBlock {
        id
        html

      }
      ... on CmsHeadingBlock {
        id
        importance
        heading
        addon
        decoration

      }
      ... on CmsTextWithIconBlock {
        id
        title
        text
        image @include(if: $withBlockDeep) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        imagePosition

      }
      ... on CmsAccordionBlock {
        id
        items @include(if: $withBlockDeep) {
          id
          title
          content
        }

      }
      ... on CmsGridBlock {
        id
        columns @include(if: $withBlockDeep) {
          id
          contentBlockAssignments  {
            id
            type
          }
        }

      }
      ... on CmsImageBlock {
        id
        image @include(if: $withBlockDeep) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        text
        fluid

      }
      ... on CmsEmployeesBlock {
        id
        employees @include(if: $withBlockDeep) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }

      }
      ... on CmsContactBannerBlock {
        id
        employee @include(if: $withBlockDeep) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        email
        phonePrefix
        phone
        phone2Prefix
        phone2

      }
      ... on CmsNewsletterRegisterBlock {
        id
        fluid

      }
      ... on CmsIssuuCatalogBlock {
        id
        publicationCode
        accountName

      }
      ... on CmsFormBlock {
        id
        formName

      }
      ... on CmsHeaderSliderBlock {
        id
        travels @include(if: $withBlockDeep) {
          id
          name
          isBestseller
          startDate
          endDate
          availabilityStatus  {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          executionStatus
          travelConsultant  {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          label  {
            id
            label
          }
          title
          description
          introVideoUrl
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          seoSettings  {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          tenantSettings  {
            id
            onlineStatus
            redirectToBooking
            useTiming
            startDate
            endDate
          }
          highlights  {
            id
            text
          }
          partners  {
            id
            name
            url
            logoWidth
          }
          travelGuides  {
            id
            firstName
            lastName
            description
          }
          teams  {
            id
            name
          }
          accommodationAssignments  {
            id
            useCustomRoomTypeSelection
            displayDetails
          }
          accommodations  {
            id
            label
            name
            stars
            description
          }
          destinations  {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          testimonials  {
            id
          }
          mainImage  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          mainVideo  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          gallery  {
            id
          }
          travelPdf  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          travelExtensions  {
            id
            duration
            name
            description
          }
          programType
          itinerary  {
            id
          }
          programText
          pricing  {
            id
            isTravelDocumentationAvailable
          }
          minPrice
          minPriceManualOverride
          currency
          faqs  {
            id
            question
            answer
          }
        }
        slides @include(if: $withBlockDeep) {
          id
          image  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          title
          text
          link  {
            id
            label
            targetBlank
            type
            url
          }
        }

      }
      ... on CmsBestsellerSliderBlock {
        id
        fluid

      }
      ... on CmsFilterLeadBlock {
        id
        layout

      }
      ... on CmsTravelTypesBlock {
        id
        layout

      }
      ... on CmsPrefilteredTravelsBlock {
        id
        destinations @include(if: $withBlockDeep) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        travelTypes @include(if: $withBlockDeep) {
          id
          name
          description
          image  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        maxResults

      }
      ... on CmsDividerBlock {
        id
        fluid

      }
      ... on CmsTravelSelectionBlock {
        id
        travels @include(if: $withBlockDeep) {
          id
          name
          isBestseller
          startDate
          endDate
          availabilityStatus  {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          executionStatus
          travelConsultant  {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          label  {
            id
            label
          }
          title
          description
          introVideoUrl
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          seoSettings  {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          tenantSettings  {
            id
            onlineStatus
            redirectToBooking
            useTiming
            startDate
            endDate
          }
          highlights  {
            id
            text
          }
          partners  {
            id
            name
            url
            logoWidth
          }
          travelGuides  {
            id
            firstName
            lastName
            description
          }
          teams  {
            id
            name
          }
          accommodationAssignments  {
            id
            useCustomRoomTypeSelection
            displayDetails
          }
          accommodations  {
            id
            label
            name
            stars
            description
          }
          destinations  {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          testimonials  {
            id
          }
          mainImage  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          mainVideo  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          gallery  {
            id
          }
          travelPdf  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          travelExtensions  {
            id
            duration
            name
            description
          }
          programType
          itinerary  {
            id
          }
          programText
          pricing  {
            id
            isTravelDocumentationAvailable
          }
          minPrice
          minPriceManualOverride
          currency
          faqs  {
            id
            question
            answer
          }
        }

      }
      ... on CmsIframeBlock {
        id
        url
        minHeight

      }
      ... on CmsSliderBlock {
        id
        fluid
        gallery @include(if: $withBlockDeep) {
          id
          images  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        size
        showDots
        showArrows
        showLightbox
        autoplay

      }
      ... on CmsDestinationsBlock {
        id
        destinations @include(if: $withBlockDeep) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }

      }
      ... on CmsTravelGuidesBlock {
        id
        travelGuides @include(if: $withBlockDeep) {
          id
          firstName
          lastName
          description
          image  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }

      }
      ... on CmsBusfinderBlock {
        id
        title

      }
      ... on CmsBackgroundBlock {
        id
        backgroundVariant
        contentBlockAssignments @include(if: $withBlockDeep) {
          id
          type
          block  {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              email
              phonePrefix
              phone
              phone2Prefix
              phone2

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
            ... on CmsButtonBlock {
              id
              variant
              size
              position

            }
          }
        }

      }
      ... on CmsButtonBlock {
        id
        variant
        size
        position
        link @include(if: $withBlockDeep) {
          id
          label
          targetBlank
          type
          url
          page  {
            id
            name
            onlineStatus
          }
          travel  {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
        }

      }
    }
  }
}`

// language=GraphQL
export const SINGLE_CONTENT_BLOCK_ASSIGNMENT_QUERY = `query Query($id: ID!, $withBlock: Boolean = false, $withBlockDeep: Boolean = false) {
  contentBlockAssignment: cmsContentBlockAssignment(id: $id) {
    id
    type
    block @include(if: $withBlock) {
      __typename
      ... on CmsTextBlock {
        id
        text

      }
      ... on CmsTextWithImageBlock {
        id
        title
        subtitle
        text
        imagePosition
        image @include(if: $withBlockDeep) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        imageFixedAspectRatio
        gallery @include(if: $withBlockDeep) {
          id
          images  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        link @include(if: $withBlockDeep) {
          id
          label
          targetBlank
          type
          url
          page  {
            id
            name
            onlineStatus
          }
          travel  {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
        }

      }
      ... on CmsPageHeaderBlock {
        id
        title
        text
        image @include(if: $withBlockDeep) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }

      }
      ... on CmsWysiwygBlock {
        id
        html

      }
      ... on CmsHeadingBlock {
        id
        importance
        heading
        addon
        decoration

      }
      ... on CmsTextWithIconBlock {
        id
        title
        text
        image @include(if: $withBlockDeep) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        imagePosition

      }
      ... on CmsAccordionBlock {
        id
        items @include(if: $withBlockDeep) {
          id
          title
          content
        }

      }
      ... on CmsGridBlock {
        id
        columns @include(if: $withBlockDeep) {
          id
          contentBlockAssignments  {
            id
            type
          }
        }

      }
      ... on CmsImageBlock {
        id
        image @include(if: $withBlockDeep) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        text
        fluid

      }
      ... on CmsEmployeesBlock {
        id
        employees @include(if: $withBlockDeep) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }

      }
      ... on CmsContactBannerBlock {
        id
        employee @include(if: $withBlockDeep) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        email
        phonePrefix
        phone
        phone2Prefix
        phone2

      }
      ... on CmsNewsletterRegisterBlock {
        id
        fluid

      }
      ... on CmsIssuuCatalogBlock {
        id
        publicationCode
        accountName

      }
      ... on CmsFormBlock {
        id
        formName

      }
      ... on CmsHeaderSliderBlock {
        id
        travels @include(if: $withBlockDeep) {
          id
          name
          isBestseller
          startDate
          endDate
          availabilityStatus  {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          executionStatus
          travelConsultant  {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          label  {
            id
            label
          }
          title
          description
          introVideoUrl
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          seoSettings  {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          tenantSettings  {
            id
            onlineStatus
            redirectToBooking
            useTiming
            startDate
            endDate
          }
          highlights  {
            id
            text
          }
          partners  {
            id
            name
            url
            logoWidth
          }
          travelGuides  {
            id
            firstName
            lastName
            description
          }
          teams  {
            id
            name
          }
          accommodationAssignments  {
            id
            useCustomRoomTypeSelection
            displayDetails
          }
          accommodations  {
            id
            label
            name
            stars
            description
          }
          destinations  {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          testimonials  {
            id
          }
          mainImage  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          mainVideo  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          gallery  {
            id
          }
          travelPdf  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          travelExtensions  {
            id
            duration
            name
            description
          }
          programType
          itinerary  {
            id
          }
          programText
          pricing  {
            id
            isTravelDocumentationAvailable
          }
          minPrice
          minPriceManualOverride
          currency
          faqs  {
            id
            question
            answer
          }
        }
        slides @include(if: $withBlockDeep) {
          id
          image  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          title
          text
          link  {
            id
            label
            targetBlank
            type
            url
          }
        }

      }
      ... on CmsBestsellerSliderBlock {
        id
        fluid

      }
      ... on CmsFilterLeadBlock {
        id
        layout

      }
      ... on CmsTravelTypesBlock {
        id
        layout

      }
      ... on CmsPrefilteredTravelsBlock {
        id
        destinations @include(if: $withBlockDeep) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }
        travelTypes @include(if: $withBlockDeep) {
          id
          name
          description
          image  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        maxResults

      }
      ... on CmsDividerBlock {
        id
        fluid

      }
      ... on CmsTravelSelectionBlock {
        id
        travels @include(if: $withBlockDeep) {
          id
          name
          isBestseller
          startDate
          endDate
          availabilityStatus  {
            id
            label
            status
            isDefaultStatus
            isDefaultWaitlistFallback
          }
          executionStatus
          travelConsultant  {
            id
            firstName
            lastName
            jobTitle
            description
            email
            phone
          }
          label  {
            id
            label
          }
          title
          description
          introVideoUrl
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          seoSettings  {
            id
            urlSlug
            metaTitle
            metaDescription
            ogTitle
            ogDescription
          }
          tenantSettings  {
            id
            onlineStatus
            redirectToBooking
            useTiming
            startDate
            endDate
          }
          highlights  {
            id
            text
          }
          partners  {
            id
            name
            url
            logoWidth
          }
          travelGuides  {
            id
            firstName
            lastName
            description
          }
          teams  {
            id
            name
          }
          accommodationAssignments  {
            id
            useCustomRoomTypeSelection
            displayDetails
          }
          accommodations  {
            id
            label
            name
            stars
            description
          }
          destinations  {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          testimonials  {
            id
          }
          mainImage  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          mainVideo  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          gallery  {
            id
          }
          travelPdf  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          travelExtensions  {
            id
            duration
            name
            description
          }
          programType
          itinerary  {
            id
          }
          programText
          pricing  {
            id
            isTravelDocumentationAvailable
          }
          minPrice
          minPriceManualOverride
          currency
          faqs  {
            id
            question
            answer
          }
        }

      }
      ... on CmsIframeBlock {
        id
        url
        minHeight

      }
      ... on CmsSliderBlock {
        id
        fluid
        gallery @include(if: $withBlockDeep) {
          id
          images  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        size
        showDots
        showArrows
        showLightbox
        autoplay

      }
      ... on CmsDestinationsBlock {
        id
        destinations @include(if: $withBlockDeep) {
          id
          name
          entryRequirements
          medicalInformation
          language
          timeShift
          climate
          currency
        }

      }
      ... on CmsTravelGuidesBlock {
        id
        travelGuides @include(if: $withBlockDeep) {
          id
          firstName
          lastName
          description
          image  {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }

      }
      ... on CmsBusfinderBlock {
        id
        title

      }
      ... on CmsBackgroundBlock {
        id
        backgroundVariant
        contentBlockAssignments @include(if: $withBlockDeep) {
          id
          type
          block  {
            __typename
            ... on CmsTextBlock {
              id
              text

            }
            ... on CmsTextWithImageBlock {
              id
              title
              subtitle
              text
              imagePosition
              imageFixedAspectRatio

            }
            ... on CmsPageHeaderBlock {
              id
              title
              text

            }
            ... on CmsWysiwygBlock {
              id
              html

            }
            ... on CmsHeadingBlock {
              id
              importance
              heading
              addon
              decoration

            }
            ... on CmsTextWithIconBlock {
              id
              title
              text
              imagePosition

            }
            ... on CmsAccordionBlock {
              id

            }
            ... on CmsGridBlock {
              id

            }
            ... on CmsImageBlock {
              id
              text
              fluid

            }
            ... on CmsEmployeesBlock {
              id

            }
            ... on CmsContactBannerBlock {
              id
              email
              phonePrefix
              phone
              phone2Prefix
              phone2

            }
            ... on CmsNewsletterRegisterBlock {
              id
              fluid

            }
            ... on CmsIssuuCatalogBlock {
              id
              publicationCode
              accountName

            }
            ... on CmsFormBlock {
              id
              formName

            }
            ... on CmsHeaderSliderBlock {
              id

            }
            ... on CmsBestsellerSliderBlock {
              id
              fluid

            }
            ... on CmsFilterLeadBlock {
              id
              layout

            }
            ... on CmsTravelTypesBlock {
              id
              layout

            }
            ... on CmsPrefilteredTravelsBlock {
              id
              maxResults

            }
            ... on CmsDividerBlock {
              id
              fluid

            }
            ... on CmsTravelSelectionBlock {
              id

            }
            ... on CmsIframeBlock {
              id
              url
              minHeight

            }
            ... on CmsSliderBlock {
              id
              fluid
              size
              showDots
              showArrows
              showLightbox
              autoplay

            }
            ... on CmsDestinationsBlock {
              id

            }
            ... on CmsTravelGuidesBlock {
              id

            }
            ... on CmsBusfinderBlock {
              id
              title

            }
            ... on CmsBackgroundBlock {
              id
              backgroundVariant

            }
            ... on CmsButtonBlock {
              id
              variant
              size
              position

            }
          }
        }

      }
      ... on CmsButtonBlock {
        id
        variant
        size
        position
        link @include(if: $withBlockDeep) {
          id
          label
          targetBlank
          type
          url
          page  {
            id
            name
            onlineStatus
          }
          travel  {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
        }

      }
    }
  }
}`

// language=GraphQL
export const CREATE_CONTENT_BLOCK_ASSIGNMENT_MUTATION = `
  mutation Mutation($input: CreateCmsContentBlockAssignmentInput, $withBlock: Boolean = false, $withBlockDeep: Boolean = false) {
    contentBlockAssignment: createCmsContentBlockAssignment(input: $input) {
      id
      type
      block @include(if: $withBlock) {
        __typename
        ... on CmsTextBlock {
          id
          text

        }
        ... on CmsTextWithImageBlock {
          id
          title
          subtitle
          text
          imagePosition
          image @include(if: $withBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imageFixedAspectRatio
          gallery @include(if: $withBlockDeep) {
            id
            images  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
          }
          link @include(if: $withBlockDeep) {
            id
            label
            targetBlank
            type
            url
            page  {
              id
              name
              onlineStatus
            }
            travel  {
              id
              name
              isBestseller
              startDate
              endDate
              executionStatus
              title
              description
              introVideoUrl
              includedServices
              excludedServices
              pricingTable
              priceCalculationInfo
              programType
              programText
              minPrice
              minPriceManualOverride
              currency
            }
          }

        }
        ... on CmsPageHeaderBlock {
          id
          title
          text
          image @include(if: $withBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }

        }
        ... on CmsWysiwygBlock {
          id
          html

        }
        ... on CmsHeadingBlock {
          id
          importance
          heading
          addon
          decoration

        }
        ... on CmsTextWithIconBlock {
          id
          title
          text
          image @include(if: $withBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imagePosition

        }
        ... on CmsAccordionBlock {
          id
          items @include(if: $withBlockDeep) {
            id
            title
            content
          }

        }
        ... on CmsGridBlock {
          id
          columns @include(if: $withBlockDeep) {
            id
            contentBlockAssignments  {
              id
              type
            }
          }

        }
        ... on CmsImageBlock {
          id
          image @include(if: $withBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          text
          fluid

        }
        ... on CmsEmployeesBlock {
          id
          employees @include(if: $withBlockDeep) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            image  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            phone
          }

        }
        ... on CmsContactBannerBlock {
          id
          employee @include(if: $withBlockDeep) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            image  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            phone
          }
          email
          phonePrefix
          phone
          phone2Prefix
          phone2

        }
        ... on CmsNewsletterRegisterBlock {
          id
          fluid

        }
        ... on CmsIssuuCatalogBlock {
          id
          publicationCode
          accountName

        }
        ... on CmsFormBlock {
          id
          formName

        }
        ... on CmsHeaderSliderBlock {
          id
          travels @include(if: $withBlockDeep) {
            id
            name
            isBestseller
            startDate
            endDate
            availabilityStatus  {
              id
              label
              status
              isDefaultStatus
              isDefaultWaitlistFallback
            }
            executionStatus
            travelConsultant  {
              id
              firstName
              lastName
              jobTitle
              description
              email
              phone
            }
            label  {
              id
              label
            }
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            seoSettings  {
              id
              urlSlug
              metaTitle
              metaDescription
              ogTitle
              ogDescription
            }
            tenantSettings  {
              id
              onlineStatus
              redirectToBooking
              useTiming
              startDate
              endDate
            }
            highlights  {
              id
              text
            }
            partners  {
              id
              name
              url
              logoWidth
            }
            travelGuides  {
              id
              firstName
              lastName
              description
            }
            teams  {
              id
              name
            }
            accommodationAssignments  {
              id
              useCustomRoomTypeSelection
              displayDetails
            }
            accommodations  {
              id
              label
              name
              stars
              description
            }
            destinations  {
              id
              name
              entryRequirements
              medicalInformation
              language
              timeShift
              climate
              currency
            }
            testimonials  {
              id
            }
            mainImage  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            mainVideo  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            gallery  {
              id
            }
            travelPdf  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            travelExtensions  {
              id
              duration
              name
              description
            }
            programType
            itinerary  {
              id
            }
            programText
            pricing  {
              id
              isTravelDocumentationAvailable
            }
            minPrice
            minPriceManualOverride
            currency
            faqs  {
              id
              question
              answer
            }
          }
          slides @include(if: $withBlockDeep) {
            id
            image  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            title
            text
            link  {
              id
              label
              targetBlank
              type
              url
            }
          }

        }
        ... on CmsBestsellerSliderBlock {
          id
          fluid

        }
        ... on CmsFilterLeadBlock {
          id
          layout

        }
        ... on CmsTravelTypesBlock {
          id
          layout

        }
        ... on CmsPrefilteredTravelsBlock {
          id
          destinations @include(if: $withBlockDeep) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          travelTypes @include(if: $withBlockDeep) {
            id
            name
            description
            image  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
          }
          maxResults

        }
        ... on CmsDividerBlock {
          id
          fluid

        }
        ... on CmsTravelSelectionBlock {
          id
          travels @include(if: $withBlockDeep) {
            id
            name
            isBestseller
            startDate
            endDate
            availabilityStatus  {
              id
              label
              status
              isDefaultStatus
              isDefaultWaitlistFallback
            }
            executionStatus
            travelConsultant  {
              id
              firstName
              lastName
              jobTitle
              description
              email
              phone
            }
            label  {
              id
              label
            }
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            seoSettings  {
              id
              urlSlug
              metaTitle
              metaDescription
              ogTitle
              ogDescription
            }
            tenantSettings  {
              id
              onlineStatus
              redirectToBooking
              useTiming
              startDate
              endDate
            }
            highlights  {
              id
              text
            }
            partners  {
              id
              name
              url
              logoWidth
            }
            travelGuides  {
              id
              firstName
              lastName
              description
            }
            teams  {
              id
              name
            }
            accommodationAssignments  {
              id
              useCustomRoomTypeSelection
              displayDetails
            }
            accommodations  {
              id
              label
              name
              stars
              description
            }
            destinations  {
              id
              name
              entryRequirements
              medicalInformation
              language
              timeShift
              climate
              currency
            }
            testimonials  {
              id
            }
            mainImage  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            mainVideo  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            gallery  {
              id
            }
            travelPdf  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            travelExtensions  {
              id
              duration
              name
              description
            }
            programType
            itinerary  {
              id
            }
            programText
            pricing  {
              id
              isTravelDocumentationAvailable
            }
            minPrice
            minPriceManualOverride
            currency
            faqs  {
              id
              question
              answer
            }
          }

        }
        ... on CmsIframeBlock {
          id
          url
          minHeight

        }
        ... on CmsSliderBlock {
          id
          fluid
          gallery @include(if: $withBlockDeep) {
            id
            images  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
          }
          size
          showDots
          showArrows
          showLightbox
          autoplay

        }
        ... on CmsDestinationsBlock {
          id
          destinations @include(if: $withBlockDeep) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }

        }
        ... on CmsTravelGuidesBlock {
          id
          travelGuides @include(if: $withBlockDeep) {
            id
            firstName
            lastName
            description
            image  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
          }

        }
        ... on CmsBusfinderBlock {
          id
          title

        }
        ... on CmsBackgroundBlock {
          id
          backgroundVariant
          contentBlockAssignments @include(if: $withBlockDeep) {
            id
            type
            block  {
              __typename
              ... on CmsTextBlock {
                id
                text

              }
              ... on CmsTextWithImageBlock {
                id
                title
                subtitle
                text
                imagePosition
                imageFixedAspectRatio

              }
              ... on CmsPageHeaderBlock {
                id
                title
                text

              }
              ... on CmsWysiwygBlock {
                id
                html

              }
              ... on CmsHeadingBlock {
                id
                importance
                heading
                addon
                decoration

              }
              ... on CmsTextWithIconBlock {
                id
                title
                text
                imagePosition

              }
              ... on CmsAccordionBlock {
                id

              }
              ... on CmsGridBlock {
                id

              }
              ... on CmsImageBlock {
                id
                text
                fluid

              }
              ... on CmsEmployeesBlock {
                id

              }
              ... on CmsContactBannerBlock {
                id
                email
                phonePrefix
                phone
                phone2Prefix
                phone2

              }
              ... on CmsNewsletterRegisterBlock {
                id
                fluid

              }
              ... on CmsIssuuCatalogBlock {
                id
                publicationCode
                accountName

              }
              ... on CmsFormBlock {
                id
                formName

              }
              ... on CmsHeaderSliderBlock {
                id

              }
              ... on CmsBestsellerSliderBlock {
                id
                fluid

              }
              ... on CmsFilterLeadBlock {
                id
                layout

              }
              ... on CmsTravelTypesBlock {
                id
                layout

              }
              ... on CmsPrefilteredTravelsBlock {
                id
                maxResults

              }
              ... on CmsDividerBlock {
                id
                fluid

              }
              ... on CmsTravelSelectionBlock {
                id

              }
              ... on CmsIframeBlock {
                id
                url
                minHeight

              }
              ... on CmsSliderBlock {
                id
                fluid
                size
                showDots
                showArrows
                showLightbox
                autoplay

              }
              ... on CmsDestinationsBlock {
                id

              }
              ... on CmsTravelGuidesBlock {
                id

              }
              ... on CmsBusfinderBlock {
                id
                title

              }
              ... on CmsBackgroundBlock {
                id
                backgroundVariant

              }
              ... on CmsButtonBlock {
                id
                variant
                size
                position

              }
            }
          }

        }
        ... on CmsButtonBlock {
          id
          variant
          size
          position
          link @include(if: $withBlockDeep) {
            id
            label
            targetBlank
            type
            url
            page  {
              id
              name
              onlineStatus
            }
            travel  {
              id
              name
              isBestseller
              startDate
              endDate
              executionStatus
              title
              description
              introVideoUrl
              includedServices
              excludedServices
              pricingTable
              priceCalculationInfo
              programType
              programText
              minPrice
              minPriceManualOverride
              currency
            }
          }

        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_CONTENT_BLOCK_ASSIGNMENT_MUTATION = `
  mutation Mutation($input: UpdateCmsContentBlockAssignmentInput, $withBlock: Boolean = false, $withBlockDeep: Boolean = false) {
    contentBlockAssignment: updateCmsContentBlockAssignment(input: $input) {
      id
      type
      block @include(if: $withBlock) {
        __typename
        ... on CmsTextBlock {
          id
          text

        }
        ... on CmsTextWithImageBlock {
          id
          title
          subtitle
          text
          imagePosition
          image @include(if: $withBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imageFixedAspectRatio
          gallery @include(if: $withBlockDeep) {
            id
            images  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
          }
          link @include(if: $withBlockDeep) {
            id
            label
            targetBlank
            type
            url
            page  {
              id
              name
              onlineStatus
            }
            travel  {
              id
              name
              isBestseller
              startDate
              endDate
              executionStatus
              title
              description
              introVideoUrl
              includedServices
              excludedServices
              pricingTable
              priceCalculationInfo
              programType
              programText
              minPrice
              minPriceManualOverride
              currency
            }
          }

        }
        ... on CmsPageHeaderBlock {
          id
          title
          text
          image @include(if: $withBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }

        }
        ... on CmsWysiwygBlock {
          id
          html

        }
        ... on CmsHeadingBlock {
          id
          importance
          heading
          addon
          decoration

        }
        ... on CmsTextWithIconBlock {
          id
          title
          text
          image @include(if: $withBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          imagePosition

        }
        ... on CmsAccordionBlock {
          id
          items @include(if: $withBlockDeep) {
            id
            title
            content
          }

        }
        ... on CmsGridBlock {
          id
          columns @include(if: $withBlockDeep) {
            id
            contentBlockAssignments  {
              id
              type
            }
          }

        }
        ... on CmsImageBlock {
          id
          image @include(if: $withBlockDeep) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          text
          fluid

        }
        ... on CmsEmployeesBlock {
          id
          employees @include(if: $withBlockDeep) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            image  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            phone
          }

        }
        ... on CmsContactBannerBlock {
          id
          employee @include(if: $withBlockDeep) {
            id
            firstName
            lastName
            jobTitle
            description
            email
            image  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            phone
          }
          email
          phonePrefix
          phone
          phone2Prefix
          phone2

        }
        ... on CmsNewsletterRegisterBlock {
          id
          fluid

        }
        ... on CmsIssuuCatalogBlock {
          id
          publicationCode
          accountName

        }
        ... on CmsFormBlock {
          id
          formName

        }
        ... on CmsHeaderSliderBlock {
          id
          travels @include(if: $withBlockDeep) {
            id
            name
            isBestseller
            startDate
            endDate
            availabilityStatus  {
              id
              label
              status
              isDefaultStatus
              isDefaultWaitlistFallback
            }
            executionStatus
            travelConsultant  {
              id
              firstName
              lastName
              jobTitle
              description
              email
              phone
            }
            label  {
              id
              label
            }
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            seoSettings  {
              id
              urlSlug
              metaTitle
              metaDescription
              ogTitle
              ogDescription
            }
            tenantSettings  {
              id
              onlineStatus
              redirectToBooking
              useTiming
              startDate
              endDate
            }
            highlights  {
              id
              text
            }
            partners  {
              id
              name
              url
              logoWidth
            }
            travelGuides  {
              id
              firstName
              lastName
              description
            }
            teams  {
              id
              name
            }
            accommodationAssignments  {
              id
              useCustomRoomTypeSelection
              displayDetails
            }
            accommodations  {
              id
              label
              name
              stars
              description
            }
            destinations  {
              id
              name
              entryRequirements
              medicalInformation
              language
              timeShift
              climate
              currency
            }
            testimonials  {
              id
            }
            mainImage  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            mainVideo  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            gallery  {
              id
            }
            travelPdf  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            travelExtensions  {
              id
              duration
              name
              description
            }
            programType
            itinerary  {
              id
            }
            programText
            pricing  {
              id
              isTravelDocumentationAvailable
            }
            minPrice
            minPriceManualOverride
            currency
            faqs  {
              id
              question
              answer
            }
          }
          slides @include(if: $withBlockDeep) {
            id
            image  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            title
            text
            link  {
              id
              label
              targetBlank
              type
              url
            }
          }

        }
        ... on CmsBestsellerSliderBlock {
          id
          fluid

        }
        ... on CmsFilterLeadBlock {
          id
          layout

        }
        ... on CmsTravelTypesBlock {
          id
          layout

        }
        ... on CmsPrefilteredTravelsBlock {
          id
          destinations @include(if: $withBlockDeep) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }
          travelTypes @include(if: $withBlockDeep) {
            id
            name
            description
            image  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
          }
          maxResults

        }
        ... on CmsDividerBlock {
          id
          fluid

        }
        ... on CmsTravelSelectionBlock {
          id
          travels @include(if: $withBlockDeep) {
            id
            name
            isBestseller
            startDate
            endDate
            availabilityStatus  {
              id
              label
              status
              isDefaultStatus
              isDefaultWaitlistFallback
            }
            executionStatus
            travelConsultant  {
              id
              firstName
              lastName
              jobTitle
              description
              email
              phone
            }
            label  {
              id
              label
            }
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            seoSettings  {
              id
              urlSlug
              metaTitle
              metaDescription
              ogTitle
              ogDescription
            }
            tenantSettings  {
              id
              onlineStatus
              redirectToBooking
              useTiming
              startDate
              endDate
            }
            highlights  {
              id
              text
            }
            partners  {
              id
              name
              url
              logoWidth
            }
            travelGuides  {
              id
              firstName
              lastName
              description
            }
            teams  {
              id
              name
            }
            accommodationAssignments  {
              id
              useCustomRoomTypeSelection
              displayDetails
            }
            accommodations  {
              id
              label
              name
              stars
              description
            }
            destinations  {
              id
              name
              entryRequirements
              medicalInformation
              language
              timeShift
              climate
              currency
            }
            testimonials  {
              id
            }
            mainImage  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            mainVideo  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            gallery  {
              id
            }
            travelPdf  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
            travelExtensions  {
              id
              duration
              name
              description
            }
            programType
            itinerary  {
              id
            }
            programText
            pricing  {
              id
              isTravelDocumentationAvailable
            }
            minPrice
            minPriceManualOverride
            currency
            faqs  {
              id
              question
              answer
            }
          }

        }
        ... on CmsIframeBlock {
          id
          url
          minHeight

        }
        ... on CmsSliderBlock {
          id
          fluid
          gallery @include(if: $withBlockDeep) {
            id
            images  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
          }
          size
          showDots
          showArrows
          showLightbox
          autoplay

        }
        ... on CmsDestinationsBlock {
          id
          destinations @include(if: $withBlockDeep) {
            id
            name
            entryRequirements
            medicalInformation
            language
            timeShift
            climate
            currency
          }

        }
        ... on CmsTravelGuidesBlock {
          id
          travelGuides @include(if: $withBlockDeep) {
            id
            firstName
            lastName
            description
            image  {
              id
              assetId
              publicId
              url
              resourceType
              format
              width
              height
              caption
              title
              description
            }
          }

        }
        ... on CmsBusfinderBlock {
          id
          title

        }
        ... on CmsBackgroundBlock {
          id
          backgroundVariant
          contentBlockAssignments @include(if: $withBlockDeep) {
            id
            type
            block  {
              __typename
              ... on CmsTextBlock {
                id
                text

              }
              ... on CmsTextWithImageBlock {
                id
                title
                subtitle
                text
                imagePosition
                imageFixedAspectRatio

              }
              ... on CmsPageHeaderBlock {
                id
                title
                text

              }
              ... on CmsWysiwygBlock {
                id
                html

              }
              ... on CmsHeadingBlock {
                id
                importance
                heading
                addon
                decoration

              }
              ... on CmsTextWithIconBlock {
                id
                title
                text
                imagePosition

              }
              ... on CmsAccordionBlock {
                id

              }
              ... on CmsGridBlock {
                id

              }
              ... on CmsImageBlock {
                id
                text
                fluid

              }
              ... on CmsEmployeesBlock {
                id

              }
              ... on CmsContactBannerBlock {
                id
                email
                phonePrefix
                phone
                phone2Prefix
                phone2

              }
              ... on CmsNewsletterRegisterBlock {
                id
                fluid

              }
              ... on CmsIssuuCatalogBlock {
                id
                publicationCode
                accountName

              }
              ... on CmsFormBlock {
                id
                formName

              }
              ... on CmsHeaderSliderBlock {
                id

              }
              ... on CmsBestsellerSliderBlock {
                id
                fluid

              }
              ... on CmsFilterLeadBlock {
                id
                layout

              }
              ... on CmsTravelTypesBlock {
                id
                layout

              }
              ... on CmsPrefilteredTravelsBlock {
                id
                maxResults

              }
              ... on CmsDividerBlock {
                id
                fluid

              }
              ... on CmsTravelSelectionBlock {
                id

              }
              ... on CmsIframeBlock {
                id
                url
                minHeight

              }
              ... on CmsSliderBlock {
                id
                fluid
                size
                showDots
                showArrows
                showLightbox
                autoplay

              }
              ... on CmsDestinationsBlock {
                id

              }
              ... on CmsTravelGuidesBlock {
                id

              }
              ... on CmsBusfinderBlock {
                id
                title

              }
              ... on CmsBackgroundBlock {
                id
                backgroundVariant

              }
              ... on CmsButtonBlock {
                id
                variant
                size
                position

              }
            }
          }

        }
        ... on CmsButtonBlock {
          id
          variant
          size
          position
          link @include(if: $withBlockDeep) {
            id
            label
            targetBlank
            type
            url
            page  {
              id
              name
              onlineStatus
            }
            travel  {
              id
              name
              isBestseller
              startDate
              endDate
              executionStatus
              title
              description
              introVideoUrl
              includedServices
              excludedServices
              pricingTable
              priceCalculationInfo
              programType
              programText
              minPrice
              minPriceManualOverride
              currency
            }
          }

        }
      }
    }
  }`

// language=GraphQL
export const DELETE_CONTENT_BLOCK_ASSIGNMENT_MUTATION = `
  mutation Mutation($input: DeleteCmsContentBlockAssignmentInput) {
    deleteCmsContentBlockAssignment(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_CONTENT_BLOCK_ASSIGNMENT_MUTATION = `
  mutation Mutation($input: DeleteCmsContentBlockAssignmentInput) {
    forceDeleteCmsContentBlockAssignment(input: $input) {
      success
    }
  }`
// language=GraphQL
export const CONTENT_BLOCK_ASSIGNMENTS_DEPENDENTS_QUERY = `query Query($id: ID!, $withCmsPages: Boolean = false, $withCmsGridBlockColumns: Boolean = false, $withCmsBackgroundBlocks: Boolean = false) {
  groupedDependents: cmsContentBlockAssignmentDependents(id: $id) {
    cmsPages @include(if: $withCmsPages) {
      id
      name
      onlineStatus
    }
    cmsGridBlockColumns @include(if: $withCmsGridBlockColumns) {
      id
    }
    cmsBackgroundBlocks @include(if: $withCmsBackgroundBlocks) {
      id
      backgroundVariant
    }
  }
}`
